<template>
  <div>
    <v-sheet class="transparent-background-color">
      <v-card class="page-card">
        <v-card-title class="mx-3">
          {{
            $t(
              isNew
                ? "CRUD.newInfo"
                : savable
                ? "CRUD.editInfo"
                : "CRUD.viewInfo",
              [$t("Announcement.ObjectName")]
            )
          }}
          <v-spacer></v-spacer>
          <v-tooltip left>
            <template v-slot:activator="{ on, attrs }">
              <v-icon
                v-bind="attrs"
                v-on="on"
                @click="
                  $emit('mode', null);
                  $emit('input', null);
                "
                >fa-times
              </v-icon>
            </template>
            <span>
              {{ $t("CRUD.backToList", [$t("Announcement.ObjectName")]) }}
            </span>
          </v-tooltip>
        </v-card-title>
        <v-progress-linear :indeterminate="loading"></v-progress-linear>
        <v-card-text>
          <ValidationObserver ref="observer">
            <v-container>
              <!-- 标题 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("AnnouncementDetail.Fields.title")
                  }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('StockContainers.Fields.container_name')"
                    rules="required"
                  >
                    <v-text-field
                      v-model="addTitle"
                      single-line
                      dense
                      hide-details
                      :hint="isNew ? '' : $t('AnnouncementDetail.nameHint')"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'title')
                          .concat(errors)
                      "
                    >
                      <template v-slot:message="{ key, message }">
                        <div :class="key == 0 ? 'danger--text' : ''">
                          {{ message }}
                        </div>
                      </template>
                    </v-text-field>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ announcement.title }}
                </v-col>
              </v-row>
              <!-- 发布人 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Announcement.creater_name") }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Announcement.creater_name')"
                    rules="required"
                  >
                    <SearcherAccountUser
                      v-model="addAccountUser"
                      noLabel
                      single-line
                      dense
                      hide-details
                      :type="[1, 2]"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'creater_name')
                          .concat(errors)
                      "
                    />
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{ announcement.creater ? announcement.creater.name : "" }}
                </v-col>
              </v-row>
              <!-- 公告类型 -->
              <v-row
                v-if="
                  settings &&
                  settings.miniprogram &&
                  settings.miniprogram.template_id == '3'
                "
              >
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Announcement.types.title") }}{{ $t("Global.colon") }}
                  <Required :show="savable" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="savable">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Announcement.types.title')"
                    rules="required"
                  >
                    <v-select
                      v-model="addType"
                      :items="$consts.announcementTypes"
                      item-value="value"
                      item-text="text"
                      dense
                      single-line
                      hide-details
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'type')
                          .concat(errors)
                      "
                    ></v-select>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    announcement.type
                      ? announcement.type == 1
                        ? $t("Announcement.types.type_one")
                        : announcement.type == 2
                        ? $t("Announcement.types.type_two")
                        : ""
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 发布类型 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Announcement.user_type.title")
                  }}{{ $t("Global.colon") }}
                  <Required :show="isNew" :mode="mode" />
                </v-col>
                <v-col cols="9" md="7" v-if="isNew">
                  <ValidationProvider
                    v-slot="{ errors }"
                    :name="$t('Announcement.user_type.title')"
                    rules="required"
                  >
                    <v-radio-group
                      row
                      v-model="user_type"
                      :error-messages="
                        $resparse
                          .getErrorMsgs(serverErrors, 'user_type')
                          .concat(errors)
                      "
                      class="mt-0"
                    >
                      <v-radio
                        :label="
                          $t('Announcement.user_type.user_type_shop', [
                            $consts.shopName(),
                          ])
                        "
                        :key="1"
                        :value="1"
                      />
                      <v-radio
                        :label="$t('Announcement.user_type.user_type_supplier')"
                        :key="2"
                        :value="2"
                      />
                      <v-radio
                        :label="
                          $t('Announcement.user_type.user_type_agent', [
                            $consts.allianceName(),
                          ])
                        "
                        :key="3"
                        :value="3"
                      />
                    </v-radio-group>
                  </ValidationProvider>
                </v-col>
                <v-col cols="9" md="7" v-else>
                  {{
                    announcement.user_type
                      ? announcement.user_type == 1
                        ? $t("Announcement.user_type.user_type_shop", [
                            $consts.shopName(),
                          ])
                        : announcement.user_type == 2
                        ? $t("Announcement.user_type.user_type_supplier")
                        : announcement.user_type == 3
                        ? $t("Announcement.user_type.user_type_agent", [
                            $consts.allianceName(),
                          ])
                        : ""
                      : ""
                  }}
                </v-col>
              </v-row>
              <!-- 公告内容 -->
              <v-row>
                <v-col cols="3" class="font-weight-bold text-right">
                  {{ $t("Announcement.context") + $t("Global.colon") }}
                </v-col>
                <v-col cols="9" v-show="savable">
                  <VEditor v-model="comment" />
                </v-col>
                <!-- <v-textarea v-model="addContext" outlined auto-grow /> -->
                <!-- <v-col cols="9" v-else>
                  {{ announcement.content }}
                </v-col> -->
                <v-col cols="9" v-show="!savable && this.announcement.content">
                  <v-card
                    outlined
                    class="pa-1 material-img"
                    id="material-comment"
                  ></v-card>
                </v-col>
              </v-row>
              <!-- 发布对象 -->
              <v-row v-if="!savable">
                <v-col cols="3" class="font-weight-bold text-right">
                  {{
                    announcement.user_type == 1
                      ? $t("AnnouncementDetail.Fields.shop", [
                          $consts.shopName(),
                        ])
                      : announcement.user_type == 2
                      ? $t("AnnouncementDetail.Fields.supplier")
                      : announcement.user_type == 3
                      ? $t("AnnouncementDetail.Fields.alliance", [
                          $consts.allianceName(),
                        ])
                      : ""
                  }}{{ $t("Global.colon") }}
                </v-col>
                <v-col cols="9">
                  <div class="mx-4 mb-4">
                    <v-data-table
                      :headers="headers"
                      :items="push_shops"
                      multi-sort
                      :footer-props="$t('$config.footer-props')"
                      class="elevation-2 px-4 pt-1"
                    >
                      <template v-slot:header.shop.shop_name>
                        {{
                          announcement.user_type == 1
                            ? $t("AnnouncementDetail.Fields.shop_name", [
                                $consts.shopName(),
                              ])
                            : announcement.user_type == 2
                            ? $t("AnnouncementDetail.Fields.supplier_name")
                            : announcement.user_type == 3
                            ? $t("AnnouncementDetail.Fields.alliance_name", [
                                $consts.allianceName(),
                              ])
                            : ""
                        }}
                      </template>
                      <template v-slot:item.shop.shop_name="{ item }">
                        {{
                          announcement.user_type == 1
                            ? item.shop.shop_name
                            : announcement.user_type == 2
                            ? item.supplier.supplier_name
                            : announcement.user_type == 3
                            ? item.alliance.alliance_business_name
                            : ""
                        }}
                      </template>
                      <template v-slot:item.is_read="{ item }">
                        {{
                          item.is_read == false
                            ? $t("AnnouncementDetail.off_read")
                            : $t("AnnouncementDetail.on_read")
                        }}
                      </template>
                    </v-data-table>
                  </div>
                </v-col>
              </v-row>
            </v-container>
          </ValidationObserver>
        </v-card-text>
      </v-card>

      <v-card class="page-opts">
        <v-card-title>
          <v-row dense>
            <v-col cols="12">
              <v-btn
                outlined
                color="secondary"
                class="elevation-1"
                block
                @click="
                  $emit('input', null);
                  $emit('mode', null);
                "
              >
                <v-icon small class="pe-1">fa-times</v-icon>
                {{ $t("CRUD.backToList", [$t("Announcement.ObjectName")]) }}
              </v-btn>
            </v-col>
            <v-col cols="12" v-if="savable">
              <!-- 保存 -->
              <v-btn
                color="success"
                block
                :disabled="loading && !announcement.id"
                @click="save()"
              >
                <v-icon small class="pe-1">fa-save</v-icon>
                {{ $t("CRUD.saveInfo", [$t("Announcement.ObjectName")]) }}
              </v-btn>
            </v-col>
          </v-row>
        </v-card-title>
      </v-card>
    </v-sheet>
  </div>
</template>
<style>
.material-img {
  width: 50% !important;
}
.material-img p {
  margin: 0;
}
.material-img p img {
  width: 100% !important;
  height: 100% !important;
}
</style>
<script>
import { ValidationObserver, ValidationProvider } from "vee-validate";
import { mapState } from "vuex";
import Consts from "@/consts.js";
import Announcement from "@/api/announcement";
import Required from "@/components/plugins/Required";
import SearcherAccountUser from "@/components/plugins/SearcherAccountUser";
import VEditor from "@/plugins/VEditor";
import i18n from "@/i18n";

export default {
  props: ["value", "mode"],
  components: {
    Required,
    VEditor,
    SearcherAccountUser,
    ValidationObserver,
    ValidationProvider,
  },

  computed: {
    isView() {
      return !this.mode || this.mode == "view";
    },
    savable() {
      return this.mode == "edit" || this.mode == "new";
    },
    isNew() {
      return this.mode == "new";
    },
    status() {
      return Consts.stock.status;
    },
    headers() {
      return [
        {
          text: i18n.t("AnnouncementDetail.Fields.shop_name"),
          align: "start",
          sortable: false,
          value: "shop.shop_name",
        },
        {
          text: i18n.t("AnnouncementDetail.Fields.status"),
          align: "start",
          sortable: false,
          value: "is_read",
        },
        {
          text: i18n.t("AnnouncementDetail.Fields.readtime"),
          align: "start",
          sortable: false,
          value: "readtime",
        },
      ];
    },
    // 使用对象展开运算符将此对象混入到外部对象中
    ...mapState(["loading", "settings"]),
  },

  data: () => ({
    serverErrors: [],
    announcement: {},
    push_shops: [],
    user_type: 1,
    addTitle: "",
    addAccountUser: null,
    addType: 1,
    comment: "",
  }),

  methods: {
    save() {
      this.serverErrors = []; //重置远端错误提示
      var data = [];
      data.push(
        this.settings &&
          this.settings.miniprogram &&
          this.settings.miniprogram.template_id == "3"
          ? {
              title: this.addTitle,
              user_id: this.addAccountUser ? this.addAccountUser.id : "",
              type: this.addType ? this.addType : "",
              content: this.comment,
              user_type: this.user_type,
            }
          : {
              title: this.addTitle,
              user_id: this.addAccountUser ? this.addAccountUser.id : "",
              content: this.comment,
              user_type: this.user_type,
            }
      );
      // console.log(data);
      // console.log(this);
      this.$refs.observer.validate().then(
        function (result) {
          // var announcement = JSON.parse(JSON.stringify(this.announcement));
          if (result) {
            Announcement.add(data[0]).then(
              function (response) {
                var announcementdata = JSON.parse(
                  JSON.stringify(response.data.announcement)
                );
                if (response.data.status.isOK()) {
                  this.$emit("save", this.announcement);
                  this.$emit("mode", null);
                  this.$emit("input", null);
                  if (announcementdata.user_type == 1) {
                    window.open(
                      "/#/announcement/push-to-shop/" + announcementdata.id,
                      "_self"
                    );
                  } else if (announcementdata.user_type == 2) {
                    window.open(
                      "/#/announcement/push-to-supplier/" + announcementdata.id,
                      "_self"
                    );
                  } else if (announcementdata.user_type == 3) {
                    window.open(
                      "/#/announcement/push-to-alliance/" + announcementdata.id,
                      "_self"
                    );
                  }
                } else if (
                  response.data.error &&
                  response.data.error.data &&
                  "ERR333" == response.data.error.code
                ) {
                  this.serverErrors = response.data.error.data;
                }
                this.Add = false;
              }.bind(this)
            );
          }
        }.bind(this)
      );
    },
  },

  watch: {
    value: {
      immediate: true, //初始赋值也调用
      handler() {
        this.serverErrors = []; //重置远端错误提示
        if (this.value && this.value.id) {
          Announcement.fetchOne(this.value.id).then(
            function (response) {
              if (response.data.status.isOK()) {
                this.announcement = response.data.announcement;
                // console.log(this.announcement);
                this.push_shops = response.data.announcement.push_shops;
              }
            }.bind(this)
          );
        } else {
          // 新建，初始化默认值
        }
        this.$scrollTop(); //返回顶部
      },
    },

    addAccountUser: {
      handler() {
        console.log(this.addAccountUser);
      },
    },
    announcement: {
      handler() {
        var node = null;

        node = document.getElementById("material-comment");
        if (node)
          node.childNodes.forEach((child) => {
            node.removeChild(child);
          });
        if (this.announcement.content) {
          node = document.getElementById("material-comment");

          if (node)
            node.append(
              new DOMParser().parseFromString(
                this.announcement.content,
                "text/html"
              ).body
            );
          console.log(node);
        }
      },
    },

    comment: {
      handler() {
        // this.context = new DOMParser().parseFromString(
        //   this.comment,
        //   "text/html"
        // ).body.childNodes[0].innerText;
      },
    },
  },
};
</script>

<style>
</style>